module.exports = __webpack_public_path__ + "static/media/logo.24547958.svg";